/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AccountSettingsDownloadDataQueryVariables = {};
export type AccountSettingsDownloadDataQueryResponse = {
    readonly listGoals: {
        readonly " $fragmentRefs": FragmentRefs<"AccountSettingsDownloadDataGenerator_goalConnection">;
    } | null;
};
export type AccountSettingsDownloadDataQuery = {
    readonly response: AccountSettingsDownloadDataQueryResponse;
    readonly variables: AccountSettingsDownloadDataQueryVariables;
};



/*
query AccountSettingsDownloadDataQuery {
  listGoals {
    ...AccountSettingsDownloadDataGenerator_goalConnection
  }
}

fragment AccountSettingsDownloadDataGenerator_goalConnection on GoalConnection {
  edges {
    node {
      readableId
      title
      description
      createdAt
      updatedAt
      type
      nextReviewAt
      dueDate
      reviewMode {
        cycleBegin {
          days
          months
        }
        cycleGoal {
          days
          months
        }
        spacedRepetition
      }
      spacedRepetitionLevel
      status
      reviews {
        edges {
          node {
            createdAt
            updatedAt
            comment
            completion
            status
            id
          }
        }
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "days",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "months",
    "storageKey": null
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountSettingsDownloadDataQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GoalConnection",
        "kind": "LinkedField",
        "name": "listGoals",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AccountSettingsDownloadDataGenerator_goalConnection"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AccountSettingsDownloadDataQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GoalConnection",
        "kind": "LinkedField",
        "name": "listGoals",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GoalEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Goal",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "readableId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nextReviewAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dueDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReviewMode",
                    "kind": "LinkedField",
                    "name": "reviewMode",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReviewCycle",
                        "kind": "LinkedField",
                        "name": "cycleBegin",
                        "plural": false,
                        "selections": (v2/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReviewCycle",
                        "kind": "LinkedField",
                        "name": "cycleGoal",
                        "plural": false,
                        "selections": (v2/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "spacedRepetition",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "spacedRepetitionLevel",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReviewConnection",
                    "kind": "LinkedField",
                    "name": "reviews",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReviewEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Review",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/),
                              (v1/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "comment",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "completion",
                                "storageKey": null
                              },
                              (v3/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2e0c0444d5a8746608b5a05eff348c1e",
    "id": null,
    "metadata": {},
    "name": "AccountSettingsDownloadDataQuery",
    "operationKind": "query",
    "text": "query AccountSettingsDownloadDataQuery {\n  listGoals {\n    ...AccountSettingsDownloadDataGenerator_goalConnection\n  }\n}\n\nfragment AccountSettingsDownloadDataGenerator_goalConnection on GoalConnection {\n  edges {\n    node {\n      readableId\n      title\n      description\n      createdAt\n      updatedAt\n      type\n      nextReviewAt\n      dueDate\n      reviewMode {\n        cycleBegin {\n          days\n          months\n        }\n        cycleGoal {\n          days\n          months\n        }\n        spacedRepetition\n      }\n      spacedRepetitionLevel\n      status\n      reviews {\n        edges {\n          node {\n            createdAt\n            updatedAt\n            comment\n            completion\n            status\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c82b8ffb3cb7e6dc1e814a2f6b3b9444';
export default node;
